import { theme } from 'antd';
import { DeletedFilled } from 'assets/images/svg';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectDevices } from 'reduxStore/devices/selectors';
import { devicesActions } from 'reduxStore/devices/slice';
import { Button, Divider, Flex, Modal, Space, Tooltip, Typography } from 'zui/Antd';

const { Text, Title } = Typography;

const DeleteDeviceModal = ({ children, visibleProp, setVisibleProp, deviceID, isLocker = false }) => {
	const {
		token: { paddingLG, fontSizeSM, marginXL, marginXS, paddingXL, paddingXS, paddingSM }
	} = theme.useToken();
	const dispatch = useDispatch();
	const devices = useSelector(selectDevices);
	const device = useMemo(() => devices.find((d) => d.deviceID === deviceID), [devices, deviceID]);

	const { deleteDeviceLoading, completeDeleteDevice } = useSelector((state) => state.Devices);
	const [internalVisible, setInternalVisible] = useState(false);
	const visible = visibleProp !== undefined ? visibleProp : internalVisible;
	const setVisible = setVisibleProp !== undefined ? setVisibleProp : setInternalVisible;

	const handleDelete = () => {
		dispatch(devicesActions.deleteDevice({ deviceID }));
	};

	const handleCancel = useCallback(() => setVisible(false), [setVisible]);

	useEffect(() => {
		if (completeDeleteDevice) handleCancel();
	}, [completeDeleteDevice, handleCancel]);

	const titleText = isLocker ? 'Locker' : 'Device';

	return (
		<>
			<Tooltip title={'Please contact support to delete a device'} placement='top'>
				<span>
					{children ? (
						children
					) : (
						<Button
							type='text'
							size='small'
							icon={<DeletedFilled color='currentColor' width={16} height={16} />}
							onClick={(e) => setVisible(true)}
							disabled={true}
						/>
					)}
				</span>
			</Tooltip>

			<Modal
				open={visible}
				onCancel={handleCancel}
				closeIcon={false}
				centered
				destroyOnClose
				footer={[
					<Flex
						align='center'
						justify='center'
						style={{ marginTop: marginXL, padding: `0px ${paddingXS}px` }}
						gap={12}
						key='footer'
					>
						<Button onClick={handleCancel} type='default' disabled={deleteDeviceLoading} block>
							Cancel
						</Button>
						<Button
							onClick={handleDelete}
							loading={deleteDeviceLoading}
							disabled={deleteDeviceLoading}
							type='primary'
							danger
							block
						>
							Delete
						</Button>
					</Flex>
				]}
				width={350}
				styles={{ content: { padding: paddingXL } }}
			>
				<Flex vertical align='center' justify='center' gap={paddingSM}>
					<DeletedFilled />
					<Flex vertical gap={paddingLG}>
						<Space
							size={paddingXS}
							direction='vertical'
							align='center'
							style={{ margin: `${paddingXS}px 0px` }}
						>
							<Title
								level={5}
								style={{
									margin: 0,
									lineHeight: '24px',
									textAlign: 'center',
									padding: `0px ${paddingXL}px`
								}}
							>
								Are you sure you want to delete this {titleText}?
							</Title>
							<Text
								style={{
									fontSize: fontSizeSM,
									lineHeight: '24px',
									textAlign: 'center',
									display: 'block'
								}}
							>
								This action is permanent and <br /> cannot be undone.
							</Text>
						</Space>

						<Flex vertical gap={marginXS}>
							<Divider orientation='center' plain style={{ margin: 0, padding: 0, marginTop: 0 }}>
								<Text style={{ fontSize: fontSizeSM, fontWeight: 200 }}>Selected {titleText}</Text>
							</Divider>
							<Text style={{ fontSize: fontSizeSM, fontWeight: 200, textAlign: 'center' }}>
								{device?.name}
							</Text>
						</Flex>
					</Flex>
				</Flex>
			</Modal>
		</>
	);
};

export default DeleteDeviceModal;
